import { trackerDelete, trackerGet, trackerPatch, trackerPost } from '../client';
import type { GroupCreate, GroupUpdate, PageResult, TrackerGroup } from '../types';

export function listGroups(params: { page?: number; page_size?: number } = {}) {
  return trackerGet<PageResult<TrackerGroup>>('/groups', params);
}

export function createGroup(body: GroupCreate) {
  return trackerPost<TrackerGroup>('/groups', body);
}

export function updateGroup(id: number, body: GroupUpdate) {
  return trackerPatch<TrackerGroup>(`/groups/${id}`, body);
}

export function deleteGroup(id: number) {
  return trackerDelete(`/groups/${id}`);
}
